import { ApiEndpointClient } from './resource-client';
const BACKEND_FOR_FRONTEND_PREFIX = 'valuation-frontend';
export class AppraiserInstructionsClient extends ApiEndpointClient {
    constructor(http) {
        super(http, BACKEND_FOR_FRONTEND_PREFIX);
    }
    getAppraiserInstructions = async ({ customerId }) => {
        return this.get('/appraiser-instructions/', {
            response: 'content-type-or-empty',
            query: customerId ? { customer_uuid: customerId } : undefined,
        });
    };
    createAppraiserInstruction = async (newInstruction) => {
        return this.post('/appraiser-instructions/', {
            response: 'content-type-or-empty',
            query: newInstruction.customer_uuid ? { customer_uuid: newInstruction.customer_uuid } : undefined,
            json: newInstruction,
        });
    };
    deleteAppraiserInstruction = async ({ instructionId }) => {
        return this.delete(`/appraiser-instructions/${instructionId}`, {
            response: 'content-type-or-empty',
        });
    };
    patchAppraiserInstruction = async ({ instructionId, operations, }) => {
        return this.patch(`/appraiser-instructions/${instructionId}`, {
            json: operations,
            response: 'content-type-or-empty',
        });
    };
    updateAppraiserInstructions = async ({ customerId, instructions, }) => {
        return this.put(`/appraiser-instructions/?customer_uuid=${customerId}`, {
            json: instructions,
            response: 'content-type-or-empty',
        });
    };
}
